import React, { useState, useEffect } from 'react'
import LoginForm from './common/components/LoginForm'
import Home from './application/Home'
import Header from "./common/components/Header"
import ErrorToast from "./common/components/ErrorToast"
import ErrorBoundary from "./common/components/ErrorBoundary"
import { Auth } from "./common/logic/Auth"
import API from "./common/logic/API"
import { applyTheme, getCachedTheme, setTheme, Theme } from "./common/logic/Theme"
import { BrowserRouter as Router } from "react-router-dom"
import BigSpinner from './common/components/BigSpinner'

function App() {
    const [username, setUsername] = useState<string | null>(null)
    const [isAdmin, setIsAdmin] = useState<boolean>(false)
    const [credentialsCheckInProgress, setCredentialsCheckInProgress] = useState(false)
    const [apiError, setApiError] = useState<{ response?: { status: number } } | null>(null)

    const loginSuccessful = (username: string) => {
        setUsername(username)
        setIsAdmin(Auth.getIsAdmin())
        setCredentialsCheckInProgress(false)
    }

    useEffect(() => {
        API.onError((error) => setApiError(error as any))
        return () => API.onError(null)
    }, [])

    useEffect(() => {
        const cachedTheme = getCachedTheme()
        if (cachedTheme !== null) {
            applyTheme(cachedTheme)
        }

        API.getVariable('ui_theme', 'string')
            .then((response: any) => {
                const theme = response.data.value as Theme
                if (theme === 'light' || theme === 'dark') {
                    setTheme(theme)
                }
            })
            .catch(() => {
                if (cachedTheme === null) {
                    applyTheme('light')
                }
            })
    }, [])

    useEffect(() => {
        const credentials = Auth.getCredentials()
        if (credentials.username && credentials.password) {
            setCredentialsCheckInProgress(true)
            Auth.validateCredentials(credentials).then(() => {
                setCredentialsCheckInProgress(false)
                setUsername(credentials.username!)
                setIsAdmin(Auth.getIsAdmin())
            }).catch(() => {
                setCredentialsCheckInProgress(false)
            })
        }
    }, [])

    const body = credentialsCheckInProgress ? <BigSpinner /> :
        (username ?
            <ErrorBoundary><Home /></ErrorBoundary> :
            <LoginForm loginCallback={loginSuccessful} />
        )

    return (
        <Router basename={process.env.REACT_APP_FINANZ_PATH}>
            <div>
                <div className="app-header">
                    <Header username={username} isAdmin={isAdmin} />
                </div>
                <div className="app-wrapper">
                    {body}
                </div>
                <ErrorToast
                    error={apiError}
                    onDismiss={() => setApiError(null)}
                />
            </div>
        </Router>
    )
}

export default App
